// extracted by mini-css-extract-plugin
export default {"ecospendText":"JDyyclzNoietE0aBHQdx"};